module.exports = __webpack_public_path__ + "assets/img/znjj_d_s_2.197dbc62.png";